import { Component } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatDrawerMode, MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { RouterOutlet } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { FooterComponent } from "./components/layout/footer/footer.component";
import { HeaderComponent } from "./components/layout/header/header.component";
import { MenuComponent } from './components/layout/menu/menu.component';
import { InformationBannerComponent } from "./components/misc/information-banner/information-banner.component";
import { O365AuthService } from './services/o365-auth.service';

@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    MatSlideToggleModule,
    MatSidenavModule,
    HeaderComponent,
    FooterComponent,
    MatCardModule,
    MenuComponent,
    InformationBannerComponent,
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  title = 'Nexus';
  mode: MatDrawerMode = 'side';

  constructor() { }

}
